import * as React from 'react'
import Button from 'Components/button'

import { ISortProps } from './interface'

interface IProps {
  onClick(item: ISortProps, line: number): void
}

export default function PriceInput({ onClick }: IProps) {
  const [low, setLow] = React.useState<string>('')
  const [high, setHigh] = React.useState<string>('')

  function handleClick() {
    let text = ''
    let mLow = parseInt(low, 10) || 0
    let mHigh = parseInt(high, 10) || 0

    if (!mLow && !mHigh) {
      return
    }

    if (!mLow) {
      text = `${mHigh}万以下`
    } else if (!mHigh) {
      text = `${mLow}万以上`
    } else {
      if (mHigh < mLow) {
        ;[mHigh, mLow] = [mLow, mHigh]
        setHigh(`${mHigh}`)
        setLow(`${mLow}`)
      }
      text = `${mLow}-${mHigh}万`
    }
    onClick(
      {
        key: 'price',
        param: `${mLow || 0},${mHigh || -1}`,
        text,
      },
      0
    )
  }
  return (
    <div className="inputs">
      <input
        value={low}
        type="number"
        onChange={e => {
          setLow(e.target.value)
        }}
      />
      <span className="line">-</span>
      <input
        value={high}
        type="number"
        onChange={e => {
          setHigh(e.target.value)
        }}
      />
      万
      <Button
        className="button"
        disabled={!low && !high}
        type="primary"
        onClick={handleClick}
      >
        确定
      </Button>
      <style jsx>
        {`
          .inputs {
            display: inline-block;
          }
          .line {
            margin: 0 2px;
          }
          input {
            width: 40px;
            height: 28px;
            padding: 0 5px;
            border-radius: 2px;
            outline: 0;
            border: solid 1px #ededed;
            background-color: #f8f8f8;
            appearance: none;
          }
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          input[type='number'] {
            -moz-appearance: textfield;
          }
          .inputs :global(.button) {
            margin-left: 12px;
          }
        `}
      </style>
    </div>
  )
}
